import 'normalize.css';
import './App.css';

import { useState, useEffect, useRef } from "react"
import { identity } from "@deso-core/identity"

import {
  getSingleProfile,
  createSubmitPostTransaction,
  avatarUrl,
  timestampToDate,
  getTransactions
} from './utils/deso-api'


function App() {
  const isRunned = useRef(false);

  const APP_NAME = 'DeSo Template App by @brootle' // aka MEMO for derived keys

  const [loggedUserPublicKey, setLoggedUserPublicKey] = useState(undefined);  
  const [loggedUserProfile, setLoggedUserProfile] = useState(undefined);  
  const [postText, setPostText] = useState('');
  const [recentPost, setRecentPost] = useState(undefined);

  const [altLoggedUsers, setAltLoggedUsers] = useState(undefined)

  const [showSwitchUserMenu, setShowSwitchUserMenu] = useState(undefined);  

  const [loading, setLoading] = useState(false);   


  const [loadedUserPublicKey, setLoadedUserPublicKey] = useState('');  
  const [transactions, setTransactions] = useState([]);     
  const [lastTransaction, setLastTransaction] = useState('');  
  const [numberOfLastLoadedTransactions, setNumberOfLastLoadedTransactions] = useState(0);  
  const [lastPublicKeyTransactionIndex  , setLastPublicKeyTransactionIndex] = useState(-1);
  const [hasMoreTransacions, setHasMoreTransacions] = useState(true);  

  const switchUsersEl = useRef(null);

  const useOnClickOutside = (ref, handler) => {
      useEffect(
        () => {
          const listener = (event) => {
            // Do nothing if clicking ref's element or descendent elements
            //console.log("event.target: ", event.target)
            if (!ref.current || ref.current.contains(event.target)) {
              return;
            }       
            handler(event);
          };
          document.addEventListener("mousedown", listener);
          document.addEventListener("touchstart", listener);
          return () => {
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
          };
        },
        [ref, handler]
      );
  }    

  useOnClickOutside(switchUsersEl, () => setShowSwitchUserMenu(false));  

  const handleSwitchUserMenuToggle = () => {
    if(!showSwitchUserMenu){
      setShowSwitchUserMenu(true)
    } else {
      setShowSwitchUserMenu(false)
    }
  }


  const updateLoggedUserProfile = async (publicKey) => {

    if(!publicKey){
      setLoggedUserProfile(undefined)
      return;
    }

    try {

      let settings = {
          PublicKeyBase58Check: publicKey
      }    
          
      const result = await getSingleProfile(settings)    
      let { Profile, error } = result

      if(error){
          console.log("error: ", error)
          setLoggedUserProfile(undefined)
      }  

      if(Profile){
        console.log("Loaded Profile: ", Profile)
        setLoggedUserProfile(Profile)
      }

    } catch (error) {
      console.log("Error: ", error)
    }   
  }


  const makeNewPost = async () => {

    setLoading(true)

    try {

      let settings = {
        UpdaterPublicKeyBase58Check: loggedUserPublicKey,
        Body: postText,
        MinFeeRateNanosPerKB: 1500
      }    
          
      const result = await createSubmitPostTransaction(settings)    
      let {error, TransactionHex} = result
      console.log("createSubmitPostTransaction result: ", result)

      if(error){
          console.log("error: ", error)
      }

      if(TransactionHex){
        const signedTransaction = await identity.signTx(TransactionHex)
        console.log("identity.signTx result: ", signedTransaction)

        const submittedTransaction = await identity.submitTx(signedTransaction)
        console.log("identity.submitTx result: ", submittedTransaction)

        let {PostEntryResponse} = submittedTransaction
        if(PostEntryResponse){
          setRecentPost(PostEntryResponse)
        }

      }      

      setLoading(false)

    } catch (error) {
      console.log("Error: ", error)
      setLoading(false)
    }   
  }
  

  const loadTransactions = async () => {

    setLoading(true)

    try {

      // loadedUserPublicKey
      
      let settings = {
        LastTransactionIDBase58Check: lastTransaction,
        Limit: 500
      }    

      // if user public key provided, change request to load this user transactions
      if(loadedUserPublicKey){
        settings = {
          PublicKeyBase58Check: loadedUserPublicKey,
          LastPublicKeyTransactionIndex: lastPublicKeyTransactionIndex,
          IsMemPool: false,
          Limit: 200
          //Limit: 10
        }           
      }
          
      const result = await getTransactions(settings)    
      let {error, Error, Transactions, LastTransactionIDBase58Check, LastPublicKeyTransactionIndex, BalanceNanos} = result
      console.log("getTransactions result: ", result)

      if(error){
          console.log("error: ", error)
      }

      if(Error){
        console.log("error: ", Error)
      }

      setNumberOfLastLoadedTransactions(Transactions.length || 0)

      // if(Transactions && LastTransactionIDBase58Check){
      if(Transactions){

        // Transactions

        // let tempTransactions = [ ...transactions, ...Transactions ] // transactions added to top
        let tempTransactions = []
        if(loadedUserPublicKey){
          // tempTransactions = [...transactions]
          // tempTransactions.push(...Transactions);
          //tempTransactions = [ ...Transactions, ...transactions ]

          //Transactions = Transactions.reverse()
          setTransactions((transactions) => [...transactions, ...Transactions]);
        } else {
          tempTransactions = [ ...transactions, ...Transactions ] // transactions added to top
          setTransactions(tempTransactions) 
        }
        
        //tempTransactions = [ ...transactions, ...Transactions ] // transactions added to top
        //setTransactions(tempTransactions) 

        setLastTransaction(LastTransactionIDBase58Check)  

        //console.log("LastPublicKeyTransactionIndex: ", LastPublicKeyTransactionIndex)
        setLastPublicKeyTransactionIndex(LastPublicKeyTransactionIndex)

        // if LastPublicKeyTransactionIndex === 0, there are no more transactions
        if(LastPublicKeyTransactionIndex === 0){
          setHasMoreTransacions(false)
        }

        // setTransactions(Transactions)  



        // const signedTransaction = await identity.signTx(TransactionHex)
        // console.log("identity.signTx result: ", signedTransaction)

        // const submittedTransaction = await identity.submitTx(signedTransaction)
        // console.log("identity.submitTx result: ", submittedTransaction)

        // let {PostEntryResponse} = submittedTransaction
        // if(PostEntryResponse){
        //   setRecentPost(PostEntryResponse)
        // }

      }      

      setLoading(false)

    } catch (error) {
      console.log("Error: ", error)
      setLoading(false)
    }   
  }

  const hasAltUsers = (obj) => {
    return Object.keys(obj).length > 0;
  }  


  useEffect(() => {

    // used this solution to prevent this code from running twice on app load
    // https://stackoverflow.com/a/72953313/6261255
    if(isRunned.current) return;
    isRunned.current = true;
  
    identity.configure({
      spendingLimitOptions: {
        // NOTE: this value is in Deso nanos, so 1 Deso * 1e9
        GlobalDESOLimit: 0.1 * 1e9, // 1 Deso
        //IsUnlimited: true, // be careful, this cancels all limits and grants unlimted transactions types and number of transactions that can be signed and submitted by the app
        // https://github.com/deso-protocol/core/blob/a836e4d2e92f59f7570c7a00f82a3107ec80dd02/lib/network.go#L244
        TransactionCountLimitMap: {
          // BASIC_TRANSFER: 'UNLIMITED', // 2 basic transfer transactions are authorized
          SUBMIT_POST: 'UNLIMITED', // 4 submit post transactions are authorized
          // UPDATE_PROFILE: 'UNLIMITED',
          // LIKE: 'UNLIMITED',
          // FOLLOW: 'UNLIMITED',
          // CREATE_POST_ASSOCIATION: 'UNLIMITED'
        },

        // need to add extra map https://github.com/deso-protocol/deso-workspace/blob/48c338918ffeb94809e64ad4be6eba9e27c90259/libs/identity/src/lib/permissions-utils.spec.ts#L140
        // permisions for assiciation transactions
        // AssociationLimitMap: [
        //   {
        //     AssociationClass: 'Post',
        //     AppScopeType: 'Any',
        //     AssociationOperation: 'Any',
        //     OpCount: 'UNLIMITED',
        //   },
        // ],        
      },
    
      // This will be associated with all of the derived keys that your application
      // authorizes.
      appName: APP_NAME,
    })
    
    identity.subscribe((state) => {

      const {currentUser, alternateUsers, event} = state;
      console.log("state: ", state)

      // SUBSCRIBE
      // LOGIN_START
      // AUTHORIZE_DERIVED_KEY_START
      // AUTHORIZE_DERIVED_KEY_END
      // LOGIN_END
      // LOGOUT_START
      // LOGOUT_END
      switch (event) {
        case 'SUBSCRIBE':
          // there can be logged user already when app loads
          setLoggedUserPublicKey(currentUser?.publicKey)
          console.log("update user profile to ", currentUser?.publicKey)
          updateLoggedUserProfile(currentUser?.publicKey)

          // set list of alternative logged users, so we can switch between them
          setAltLoggedUsers(alternateUsers)
          break;    
        case 'LOGIN_START':
          // 
          break;      
        case 'LOGIN_END':
          // 
          setLoggedUserPublicKey(currentUser?.publicKey)
          console.log("update user profile to ", currentUser?.publicKey)
          updateLoggedUserProfile(currentUser?.publicKey)

          // set list of alternative logged users, so we can switch between them
          setAltLoggedUsers(alternateUsers)             
          break;   
        case 'CHANGE_ACTIVE_USER':
          // 
          setLoggedUserPublicKey(currentUser?.publicKey)
          console.log("update user profile to ", currentUser?.publicKey)
          updateLoggedUserProfile(currentUser?.publicKey)

          // set list of alternative logged users, so we can switch between them
          setAltLoggedUsers(alternateUsers)          
          break;             
        case 'AUTHORIZE_DERIVED_KEY_START':
          // 
          break;   
        case 'AUTHORIZE_DERIVED_KEY_END':
          // 
          break;                                                
        case 'LOGOUT_START':
          //     
          break;         
        case 'LOGOUT_END':
          // 
          setLoggedUserPublicKey(currentUser?.publicKey)
          console.log("update user profile to ", currentUser?.publicKey)
          updateLoggedUserProfile(currentUser?.publicKey)

          // set list of alternative logged users, so we can switch between them
          setAltLoggedUsers(alternateUsers)             
          break;        
        default:
          console.log(`Event: ${event}.`);
      }      
    });    

    //loadTransactions()
    
  }, [])  

  const findFollowedPublicKey = (AffectedPublicKeys) => {
    AffectedPublicKeys = AffectedPublicKeys.filter(publicKey => publicKey.Metadata === "FollowedPublicKeyBase58Check")
    return AffectedPublicKeys[0]?.PublicKeyBase58Check
  }

  const findLikedPublicKey = (AffectedPublicKeys) => {
    AffectedPublicKeys = AffectedPublicKeys.filter(publicKey => publicKey.Metadata === "PosterPublicKeyBase58Check")
    return AffectedPublicKeys[0]?.PublicKeyBase58Check
  }

  const findRepliedToPublicKey = (AffectedPublicKeys) => {
    AffectedPublicKeys = AffectedPublicKeys.filter(publicKey => publicKey.Metadata === "ParentPosterPublicKeyBase58Check")
    return AffectedPublicKeys[0]?.PublicKeyBase58Check
  }

  const diamondLevelIcon = (DiamondLevel) => {
    return '💎'.repeat(DiamondLevel)
  }

  const timestampToDate = (TimestampNanos) => {
    return new Date(Math.round(TimestampNanos/1000000)).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) + ", " + new Date(Math.round(TimestampNanos/1000000)).toLocaleTimeString('en-GB')
  }

  const timestampSecsToDate = (timestampSecs) => {
    const date = new Date(timestampSecs * 1000);
    return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) + ", " + date.toLocaleTimeString('en-GB');
  }  

  useEffect(() => {
    // reset when loadedUserPublicKey is changed
    setTransactions([])  
    setLastTransaction('')
    setNumberOfLastLoadedTransactions(0)
    setLastPublicKeyTransactionIndex(-1)
    setHasMoreTransacions(true)
  },[loadedUserPublicKey])

 
  // https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=3JuESwXKYDSkq3eBrGQ6ik6E4D2xZ6B18PWMT95jB5fovhKKUxNMCC
  // https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=3JuETKmkFY5v2XrqtDLR41bDSCxbfCL8p1RAzAzFCjsoX72kp42DMq
  // https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=3JuEUWnJwkUcFUu4JDjvobw2fdciAhsvS4aNSJmgM4cxN4jKHHAhrJ

  return (
    <div className="App">

      <div className='layoutBackground'></div>

      <header className='headerContainer'>

        <div className='headerLeft'>

          { loggedUserProfile && 
            <div className='avatarContainer'>
              <a className='avatar' 
                style={  {backgroundImage: `url(${avatarUrl(loggedUserProfile)})`} }
                href={`https://www.gemstori.com/@${loggedUserProfile?.Username}`}
                target="_blank"
                rel="noreferrer"
                title={`${loggedUserProfile?.Username}`}
              >
              </a>
            </div>
          }

          {
            loggedUserPublicKey && !loggedUserProfile &&
            <div className='avatarContainer'>
              <a className='avatar' 
                style={  {backgroundImage: `url(https://node.deso.org/assets/img/default_profile_pic.png)`} }
                href={`https://www.openprosper.com/pk/${loggedUserPublicKey}`}
                target="_blank"                
                rel="noreferrer"
                title={`${loggedUserPublicKey}`}
              >
              </a>
            </div>            
          }

          <div className='manageUsersContainer'>

            <div onClick={() => identity.login()} className="manageUserButton" title='Add user' role="button">
              <svg viewBox="0 0 24 24" className='userMenuIcon'>
                <path
                  d="M3 19c.691-2.307 2.47-3 6.5-3 4.03 0 5.809.693 6.5 3"
                  stroke="white"
                  strokeWidth={2}
                  strokeLinecap="round"
                />
                <path
                  d="M13 9.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
                  stroke="white"
                  strokeWidth={2}
                />
                <path
                  d="M15 6h6M18 3v6"
                  stroke="white"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>              
            </div>

            {
              altLoggedUsers && hasAltUsers(altLoggedUsers) &&
                <div ref={switchUsersEl} onClick={() => handleSwitchUserMenuToggle()} className="manageUserButton" title='Switch user' role="button">
                  <svg viewBox="0 0 24 24" className='userMenuIcon'>
                    <path
                      d="M15.631 7.155a2.5 2.5 0 1 1 0 4.69M3 19c.691-2.307 2.47-3 6.5-3 4.03 0 5.809.693 6.5 3M17 15c2.403.095 3.53.638 4 2"
                      stroke="white"
                      strokeWidth={2}
                      strokeLinecap="round"
                    />
                    <path
                      d="M13 9.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
                      stroke="white"
                      strokeWidth={2}
                    />
                  </svg>

                  {
                    showSwitchUserMenu && 
                    <div className='altUsersContainer'>                  
                      {altLoggedUsers && Object.keys(altLoggedUsers).map((key, index) => {
                        return (
                          <div key={index}>
                            <button className='altUserBtn' onClick={() => identity.setActiveUser(key)}

                              style={ 
                                {backgroundImage: `url(https://node.deso.org/api/v0/get-single-profile-picture/${key}?fallback=https://node.deso.org/assets/img/default_profile_pic.png)`}
                              }        
                            >
                              
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  }
                </div>
            }  
            
          </div>             
        </div>

        <div className='headerCenter'>

        </div>

        <div className='headerRight'>


          <div className='authContainer'>
            { loggedUserPublicKey
              ?<button onClick={() => identity.logout()}>Log out</button> 
              :<button onClick={() => identity.login()}>Log in</button>
            }                      
          </div>
        </div>        
 
      </header>

      <main className='mainContainer'>

        <div className='instructionsContainer'>
          <h1>[ DeSo Transactions ]</h1>     
          <p>
            By default this app returns DeSo Transactions from MemPool, transactions are returned from oldest to newest, 
            first you need to go through all older transactions to start getting fresh ones, this transactions well 
            can be 1000+ transactions deep. So at 1st max number of transactions is loaded.           
          </p>
          <p>
            Each next click loads fresh transaction similar like Twitter feed does. If you click load, but no new transactions added, 
            it means that maybe you clicked too fast and no new transactions were made yet by DeSo users. In this case wait for some time
            and try again. If it still doesn't load new transactions it means that last displayed transaction has already been 
            mined with the block. Blocks accumulate transactions and get mined ever few minutes. In this case simply reload the app.
          </p>
          <p>
            If you provide user Public Key, app will load all transactions associatied with that Public Key, it means transactions maded by 
            the user and transactions where user was affected. MemPool transactions are not included. Transactions are listed in same manner 
            as Posts Feed where latest transactions are on top and each click loads older transactions.
          </p>
        </div>


        <div className='loadProfileContainer'> 
          <input 
              disabled={loading}
              type="text" 
              value={loadedUserPublicKey} 
              onChange={e => setLoadedUserPublicKey(e.target.value)} 
              placeholder="Enter user Public Key"
            ></input>
            
        </div>

        {
          !loadedUserPublicKey
          &&
          <>
            <div className='transactionsNumber'>Loaded {numberOfLastLoadedTransactions} new transaction. {transactions.length} displayed.</div>

            <div className='loadProfileContainer'> 
              <button onClick={loadTransactions}  disabled={loading}>Load Transactions</button>  
            </div>          
          </>
        }



        {
          transactions && transactions.length > 0
          ?
          <div className={loadedUserPublicKey ? 'transactionsContainer' : 'transactionsContainer reversed'}>
          
            {transactions.map((transaction, index) => (                   
              // <div key={index} className={loading ? 'transactionContainer' : 'transactionContainer fade-in'}>
              <div key={index} className={'transactionContainer'}>
                {/* <div className='transactionHeader'>        
                  <div className='transactionHeaderRow'>                        
                  Transactor: <a 
                      className='transactorPubkicKey link'
                      href={`https://www.openprosper.com/pk/${transaction?.TransactionMetadata?.TransactorPublicKeyBase58Check}`}
                      target="_blank"
                      rel="noreferrer"
                      title="User data by Public Key at OpenProsper"
                    >
                      {transaction?.TransactionMetadata?.TransactorPublicKeyBase58Check}
                    </a> 
                  </div>
                  <div className='transactionHeaderRow'>
                    Transaction:&nbsp;
                  

                    <a className='transactionType link'
                                href={`https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=${transaction?.TransactionIDBase58Check}`}
                                target="_blank"
                                rel="noreferrer"
                                title="See transaction at https://explorer.deso.org"
                    >{transaction?.TransactionType}</a>  
                  </div>
                </div> */}

                {/* <div className='transactionHeader'>        
                  <div className='transactionHeaderRow'> 
                    {timestampSecsToDate(transaction.BlockInfo.TimestampSecs)}
                  </div>
                </div> */}
                
                <div className='transactionBody'>
                  <a className='transactorAvatar'
                    style={ 
                      {backgroundImage: `url(https://node.deso.org/api/v0/get-single-profile-picture/${transaction?.TransactionMetadata?.TransactorPublicKeyBase58Check}?fallback=https://node.deso.org/assets/img/default_profile_pic.png)`}
                    }    

                    href={`https://www.gemstori.com/${transaction?.TransactionMetadata?.TransactorPublicKeyBase58Check}`}
                    target="_blank"
                    rel="noreferrer"
                    title="User profile at Gemstori"

                  ></a>

                  <div className='transactionDescription'>

                    <div className='transactionTypeContainer'>
                      <a className='transactionType link'
                                  href={`https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=${transaction?.TransactionIDBase58Check}`}
                                  target="_blank"
                                  rel="noreferrer"
                                  title="See transaction at https://explorer.deso.org"
                      >{transaction?.TransactionType}</a>                     
                    </div>

                    {
                      transaction.TransactionType === "SUBMIT_POST" &&
                      <>
                          {
                            transaction?.TransactionMetadata?.SubmitPostTxindexMetadata?.ParentPostHashHex 
                            ?                          
                            <div className='message'>
                              Replied to&nbsp; 
                                <a className='link'
                                  href={`https://www.gemstori.com/posts/${transaction?.TransactionMetadata?.SubmitPostTxindexMetadata?.ParentPostHashHex}`}
                                  target="_blank"
                                  rel="noreferrer"
                                  title="User profile at Gemstori"

                                >post</a>     

                                {
                                  transaction.TransactionMetadata?.AffectedPublicKeys
                                  ?
                                  <>
                                    &nbsp;📄 by&nbsp; 

                                    <a className='effectedUserAvatar'
                                      style={ 
                                        {backgroundImage: `url(https://node.deso.org/api/v0/get-single-profile-picture/${findRepliedToPublicKey(transaction.TransactionMetadata?.AffectedPublicKeys)}?fallback=https://node.deso.org/assets/img/default_profile_pic.png)`}
                                      }    

                                      href={`https://www.gemstori.com/${findRepliedToPublicKey(transaction.TransactionMetadata?.AffectedPublicKeys)}`}
                                      target="_blank"
                                      rel="noreferrer"
                                      title="User profile at Gemstori"

                                    ></a>                                   
                                  </>
                                  :<></>
                                }

        
                                
                                &nbsp;See reply 🗨️&nbsp; 
                                
                                <a className='link'
                                  href={`https://www.gemstori.com/posts/${transaction.TransactionMetadata.SubmitPostTxindexMetadata.PostHashBeingModifiedHex}`}
                                  target="_blank"
                                  rel="noreferrer"
                                  title="See post at Gemstori"
                                >here</a>                                                                                      
                            </div>
                            :
                            <div className='message'>

                                Submitted a&nbsp; 
                                
                                <a className='link'
                                  href={`https://www.gemstori.com/posts/${transaction.TransactionMetadata.SubmitPostTxindexMetadata.PostHashBeingModifiedHex}`}
                                  target="_blank"
                                  rel="noreferrer"
                                  title="See post at Gemstori"
                                >post</a>
                                
                                &nbsp;📄                                                                                     
                            </div>                    
                          }
                      </>
                    }              

                    {
                      transaction.TransactionType === "FOLLOW" &&
                      <div className='message'>
                        {
                          transaction.FollowTxindexMetadata?.IsUnfollow
                          ?<>Unfollowed</>
                          :<>Followed 👀</>
                        }

                        &nbsp; 

                        <a className='effectedUserAvatar'
                          style={ 
                            {backgroundImage: `url(https://node.deso.org/api/v0/get-single-profile-picture/${findFollowedPublicKey(transaction.TransactionMetadata?.AffectedPublicKeys)}?fallback=https://node.deso.org/assets/img/default_profile_pic.png)`}
                          }    

                          href={`https://www.gemstori.com/${findFollowedPublicKey(transaction.TransactionMetadata?.AffectedPublicKeys)}`}
                          target="_blank"
                          rel="noreferrer"
                          title="User profile at Gemstori"

                        ></a>                        

                        {/* {findFollowedPublicKey(transaction.TransactionMetadata?.AffectedPublicKeys)} */}
                      </div>
                    }

                    {
                      transaction.TransactionType === "LIKE" &&
                      <div className='message'>
                        {
                          transaction?.LikeTxindexMetadata?.IsUnlike
                          ?<span>Unliked</span>
                          :<span>Liked 🧡</span>
                        }

                        &nbsp; 

                        <a className='link'
                          href={`https://www.gemstori.com/posts/${transaction?.TransactionMetadata?.LikeTxindexMetadata?.PostHashHex}`}
                          target="_blank"
                          rel="noreferrer"
                          title={`See post at Gemstori`}
                        >post</a>

                        &nbsp;📄 by&nbsp;  

                        <a className='effectedUserAvatar'
                          style={ 
                            {backgroundImage: `url(https://node.deso.org/api/v0/get-single-profile-picture/${findLikedPublicKey(transaction.TransactionMetadata?.AffectedPublicKeys)}?fallback=https://node.deso.org/assets/img/default_profile_pic.png)`}
                          }    

                          href={`https://www.gemstori.com/${findLikedPublicKey(transaction.TransactionMetadata?.AffectedPublicKeys)}`}
                          target="_blank"
                          rel="noreferrer"
                          title="User profile at Gemstori"

                        ></a>                                           
                      
                      </div>
                    }            


                    {
                      transaction.TransactionType === "BASIC_TRANSFER" &&
                      <>

                        {
                          transaction?.TransactionMetadata?.BasicTransferTxindexMetadata?.DiamondLevel
                          ?
                          <div className='message'>
                            Gave {diamondLevelIcon(transaction?.TransactionMetadata?.BasicTransferTxindexMetadata?.DiamondLevel)} to&nbsp;
                            
                            <a className='link'
                                  href={`https://www.gemstori.com/posts/${transaction?.TransactionMetadata?.BasicTransferTxindexMetadata?.PostHashHex}`}
                                  target="_blank"
                                  rel="noreferrer"
                                  title="User profile at Gemstori"

                            >post</a>                                                    
                          </div>
                          :<div className='message'>
                            See transaction&nbsp; 

                            <a className='link'
                                  href={`https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=${transaction.TransactionIDBase58Check}`}
                                  target="_blank"
                                  rel="noreferrer"
                                  title="See transaction at https://explorer.deso.org"
                            >here</a>    

                          </div>
                        }
                        
                      </>
                    }

                    {
                      transaction.TransactionType === "UPDATE_PROFILE" &&
                      <div className='message'>
                          See transaction&nbsp; 

                          <a className='link'
                                href={`https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=${transaction.TransactionIDBase58Check}`}
                                target="_blank"
                                rel="noreferrer"
                                title="See transaction at https://explorer.deso.org"
                          >here</a>                        
                      </div>
                    }

                    {
                      transaction.TransactionType === "CREATE_NFT" &&
                      <div className='message'>
                          See transaction&nbsp; 

                          <a className='link'
                                href={`https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=${transaction.TransactionIDBase58Check}`}
                                target="_blank"
                                rel="noreferrer"
                                title="See transaction at https://explorer.deso.org"
                          >here</a>                        
                      </div>
                    }    

                    {
                      transaction.TransactionType === "CREATE_POST_ASSOCIATION" &&
                      <div className='message'>
                          See transaction&nbsp; 

                          <a className='link'
                                href={`https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=${transaction.TransactionIDBase58Check}`}
                                target="_blank"
                                rel="noreferrer"
                                title="See transaction at https://explorer.deso.org"
                          >here</a>                        
                      </div>
                    }   

                    {
                      transaction.TransactionType === "AUTHORIZE_DERIVED_KEY" &&
                      <div className='message'>
                          See transaction&nbsp; 

                          <a className='link'
                                href={`https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=${transaction.TransactionIDBase58Check}`}
                                target="_blank"
                                rel="noreferrer"
                                title="See transaction at https://explorer.deso.org"
                          >here</a>                        
                      </div>
                    }          

                    {
                      transaction.TransactionType === "UPDATE_NFT" &&
                      <div className='message'>

                          Updated NFT.&nbsp; 
                          
                          {
                            transaction?.TransactionMetadata?.UpdateNFTTxindexMetadata?.IsForSale
                            ?<>This NFT is for sale.&nbsp;</>
                            :<>This NFT is not for sale.&nbsp;</>
                          }                        
                          
                          You can check it&nbsp;  

                          <a className='link'
                            href={`https://nftz.zone/nft/${transaction?.TransactionMetadata?.UpdateNFTTxindexMetadata?.NFTPostHashHex}`}
                            target="_blank"
                            rel="noreferrer"
                            title="See NFT at NFTz"
                          >here</a>
                      </div>
                    }   

                    {
                      transaction.TransactionType === "ACCEPT_NFT_TRANSFER" &&
                      <div className='message'>

                        Accepted&nbsp;  

                        <a className='link'
                            href={`https://nftz.zone/nft/${transaction?.TransactionMetadata?.AcceptNFTTransferTxindexMetadata?.NFTPostHashHex}`}
                            target="_blank"
                            rel="noreferrer"
                            title="See NFT at NFTz"
                        >NFT</a>&nbsp;                  

                        {
                          transaction?.TransactionMetadata?.AcceptNFTTransferTxindexMetadata?.SerialNumber
                          ?<>with serial #{transaction?.TransactionMetadata?.AcceptNFTTransferTxindexMetadata?.SerialNumber}</>
                          :<></>
                        }      
                      </div>
                    }       
        
                    {
                      transaction.TransactionType === "BURN_NFT" &&
                      <div className='message'>
                          See transaction&nbsp; 

                          <a className='link'
                                href={`https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=${transaction.TransactionIDBase58Check}`}
                                target="_blank"
                                rel="noreferrer"
                                title="See transaction at https://explorer.deso.org"
                          >here</a>                        
                      </div>
                    }              

                    {
                      transaction.TransactionType === "DAO_COIN_TRANSFER" &&
                      <div className='message'>
                          See transaction&nbsp; 

                          <a className='link'
                                href={`https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=${transaction.TransactionIDBase58Check}`}
                                target="_blank"
                                rel="noreferrer"
                                title="See transaction at https://explorer.deso.org"
                          >here</a>                        
                      </div>
                    }                  

                    {
                      transaction.TransactionType === "NEW_MESSAGE" &&
                      <div className='message'>
                          See transaction&nbsp; 

                          <a className='link'
                                href={`https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=${transaction.TransactionIDBase58Check}`}
                                target="_blank"
                                rel="noreferrer"
                                title="See transaction at https://explorer.deso.org"
                          >here</a>                        
                      </div>
                    }   

                    {
                      transaction.TransactionType === "ACCESS_GROUP" &&
                      <div className='message'>
                          See transaction&nbsp; 

                          <a className='link'
                                href={`https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=${transaction.TransactionIDBase58Check}`}
                                target="_blank"
                                rel="noreferrer"
                                title="See transaction at https://explorer.deso.org"
                          >here</a>                        
                      </div>
                    }       

                    {
                      transaction.TransactionType === "CREATOR_COIN" &&
                      <div className='message'>
                          See transaction&nbsp; 

                          <a className='link'
                                href={`https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=${transaction.TransactionIDBase58Check}`}
                                target="_blank"
                                rel="noreferrer"
                                title="See transaction at https://explorer.deso.org"
                          >here</a>                        
                      </div>
                    }     

                    {
                      transaction.TransactionType === "PRIVATE_MESSAGE" &&
                      <div className='message'>
                          See transaction&nbsp; 

                          <a className='link'
                                href={`https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=${transaction.TransactionIDBase58Check}`}
                                target="_blank"
                                rel="noreferrer"
                                title="See transaction at https://explorer.deso.org"
                          >here</a>                        
                      </div>
                    }                  

                    {
                      transaction.TransactionType === "NFT_TRANSFER" &&
                      <div className='message'>
                          See transaction&nbsp; 

                          <a className='link'
                                href={`https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=${transaction.TransactionIDBase58Check}`}
                                target="_blank"
                                rel="noreferrer"
                                title="See transaction at https://explorer.deso.org"
                          >here</a>                        
                      </div>
                    }            

                    {
                      transaction.TransactionType === "DAO_COIN_LIMIT_ORDER" &&
                      <div className='message'>
                          See transaction&nbsp; 

                          <a className='link'
                                href={`https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=${transaction.TransactionIDBase58Check}`}
                                target="_blank"
                                rel="noreferrer"
                                title="See transaction at https://explorer.deso.org"
                          >here</a>                        
                      </div>
                    }   

                    {
                      transaction.TransactionType === "NFT_BID" &&
                      <div className='message'>
                          See transaction&nbsp; 

                          <a className='link'
                                href={`https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=${transaction.TransactionIDBase58Check}`}
                                target="_blank"
                                rel="noreferrer"
                                title="See transaction at https://explorer.deso.org"
                          >here</a>                        
                      </div>
                    }  

                    {
                      transaction.TransactionType === "ACCEPT_NFT_BID" &&
                      <div className='message'>
                          See transaction&nbsp; 

                          <a className='link'
                                href={`https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=${transaction.TransactionIDBase58Check}`}
                                target="_blank"
                                rel="noreferrer"
                                title="See transaction at https://explorer.deso.org"
                          >here</a>                        
                      </div>
                    }                    

                    {
                      transaction.TransactionType === "DELETE_POST_ASSOCIATION" &&
                      <div className='message'>
                          See transaction&nbsp; 

                          <a className='link'
                                href={`https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=${transaction.TransactionIDBase58Check}`}
                                target="_blank"
                                rel="noreferrer"
                                title="See transaction at https://explorer.deso.org"
                          >here</a>                        
                      </div>
                    }                                                                                                
                                  
                                  
                    {
                      transaction.TransactionType === "CREATOR_COIN_TRANSFER" &&
                      <div className='message'>
                          See transaction&nbsp; 

                          <a className='link'
                                href={`https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=${transaction.TransactionIDBase58Check}`}
                                target="_blank"
                                rel="noreferrer"
                                title="See transaction at https://explorer.deso.org"
                          >here</a>                        
                      </div>
                    }     

                    {
                      transaction.TransactionType === "MESSAGING_GROUP" &&
                      <div className='message'>
                          See transaction&nbsp; 

                          <a className='link'
                                href={`https://explorer.deso.org/?query-node=https:%2F%2Fnode.deso.org&transaction-id=${transaction.TransactionIDBase58Check}`}
                                target="_blank"
                                rel="noreferrer"
                                title="See transaction at https://explorer.deso.org"
                          >here</a>                        
                      </div>
                    }                                  
        
                      

                  </div>

                </div>


              </div>
                // <Post post={post} author={user} key={index} PostProfileEntryResponse={userProfile} />                
            ))}  

            {/* <div className='loadProfileContainer'> 
              <button onClick={loadTransactions}  disabled={loading}>Load Transactions</button>  
            </div> */}

          </div>
          :<></>
        }

        {
          loadedUserPublicKey
          &&
          <>
            <div className='transactionsNumber'>Loaded {numberOfLastLoadedTransactions} more transaction. {transactions.length} displayed.</div>

            {
              hasMoreTransacions
              ?
              <div className='loadProfileContainer'> 
                <button onClick={loadTransactions}  disabled={loading}>Load Transactions</button>  
              </div>   
              :
              <div className='transactionsMessage'>No more transactions found.</div>
            }       
          </>
        }

      </main>

      <footer className='footerContainer'>
        <div className='footerLeft'>
          <div className='madeByMessage'>
            Designed by <a href='https://www.gemstori.com/@brootle' target="_blank" rel="noreferrer">brootle</a>
          </div>
        </div>
        <div className='footerRight'>
          {loading && <span>Processing...</span>}
        </div>
      </footer>

    </div>
  );
}

export default App;
